import styled from "styled-components";

const PageSections = styled.div``;

export { PageSections };
